<template>
  <div class="header-wrapper">
    <!-- logo -->
    <div class="header-left" :style="{ width: collapse ? '65px' : '' }">
      <img class="logo1" v-if="logo" :src="logo" alt="logo">
      <span class="logo1" v-else>{{adminInfo?.name || "后台系统"}}</span>
    </div>
    <div class="header-right" :style="{ color: headTextColor ? headTextColor : '#000' }">
      <div class="adminRole">{{ roleName }}</div>
      <!-- 项目选项卡容器 -->
      <div class="project-tabs-container">
        <el-dropdown 
          v-for="project in otherProjectsList"
          :key="project.projectName" 
          class="project-tab"
          :hide-on-click="Number(project.project) !== 0"
        >
          <div class="project-tab-title">
              <span class="project-name">{{ project.projectName }}</span> 
              <span v-if="project.project == 0">({{project.roles.length}}) </span>                 
            <el-icon class="project-arrow" color="#fff"><ArrowDown /></el-icon>
          </div>
          <template #dropdown>
            <div v-if="project.project == 0" class="project-dropdown-menu project-dropdown-menu--menu">
              <el-menu  class="project-role-menu" mode="vertical">
                <RoleMenuItem
                  v-for="role in project.roles"
                  :key="`${role.roleId ?? ''}-${role.adminId ?? ''}-${role.adminName ?? ''}`"
                  :role="role"
                  :navigate="navigateToRole"
                />
              </el-menu>
            </div>

            <el-dropdown-menu v-else class="project-dropdown-menu">
              <el-dropdown-item :divided="roleIndex == 0 ? false : true" class="el-dropdown-item-l" v-for="(role,roleIndex) in project.roles" :key="role.roleId">
                <span 
                  @click="!role.isLoginIn && navigateToRole(role.pcSiteUrl, role)" 
                  class="role-item"
                  :class="{ 'disabled-role': role.isLoginIn }"
                >
                  <el-icon class="role-icon"><User /></el-icon>
                  {{ role.roleName }}
                  <template v-if="role.isLinkAdminId">({{role.adminName}})</template>
                  <span v-if="role.isLoginIn" class="current-role-tag">当前</span>
                </span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
      <div>
        <el-dropdown class="custom-dropdown">
          <div class="dropdown_title">
            <img class="role-logo" v-if="adminLogo" :src="adminLogo" alt="logo" />
            <el-icon class="title-i" v-else><User /></el-icon>
            <span class="">{{ adminName }}</span>
            <el-icon class="title-i-r"><ArrowDown /></el-icon>
          </div>
          <template #dropdown>
            <el-dropdown-menu class="custom-dropdown-list">
              <el-dropdown-item v-if="isChangePassword">
                <span class="item-btn" @click="setPasswordClick">
                  <el-icon class="item-i"><Lock /></el-icon>
                  修改密码</span>
              </el-dropdown-item>
              <el-dropdown-item v-if="isChangeDingUser">
                <div @click="setAdminDDUser">
                  <el-icon class="item-i"><User /></el-icon>
                  绑定钉钉账号</div>
              </el-dropdown-item>
              <el-dropdown-item :divided="(isChangePassword || isChangeDingUser) ? true : false">
                <span class="item-btn" @click="logoutClick">
                  <el-icon class="item-i"><SwitchButton /></el-icon>安全退出</span>
              </el-dropdown-item>
            </el-dropdown-menu>
          </template>
        </el-dropdown>
      </div>
    </div>
    <!-- 资料设置表单 -->
    <el-dialog
      draggable
      title="修改密码"
      v-if="dialogVisible"
      v-model="dialogVisible"
      :before-close="handleClose"
      width="450px"
    >
      <el-form
        ref="ruleFormRef"
        :model="ruleForm"
        :rules="rules"
        label-width="120px"
        class="demo-ruleForm"
        status-icon
      >
        <el-form-item label="新密码" prop="passWord">
          <el-input
            v-model="ruleForm.passWord"
            type="password"
            show-password
            placeholder="请输入密码"
          />
        </el-form-item>
        <el-form-item label="确认新密码" prop="passWordConfirm">
          <el-input
            v-model="ruleForm.passWordConfirm"
            type="password"
            show-password
            placeholder="请再次输入密码"
          />
        </el-form-item>
        <el-form-item>
          <el-button @click="handleClose">取消</el-button>
          <el-button type="primary" @click="submitForm('ruleFormRef')"
          :disabled="loadingPass">{{loadingPass?'提交中':'提交'}}</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
     <!-- 绑定钉钉账号 -->
     <el-dialog
     draggable
     title="绑定钉钉账号"
     v-if="dialogVisibleDD"
     v-model="dialogVisibleDD"
     :before-close="handleClose"
     width="450px"
     class="dialog_DD"
   >
     <el-form
       ref="ruleFormRefDD"
       :model="ruleFormDD"
       :rules="rulesDD"
       label-width="110px"
       class="demo-ruleForm"
       status-icon
     >
     <el-form-item label="绑定钉钉账号" prop="ddUserId">
      <el-button
        style="width: 300px"
        :plain="true"
        @click="clickDingModule()"
        class="relation-btn"
      >
        <el-icon> <Plus /> </el-icon>&nbsp;&nbsp;
        {{
          !ruleFormDD.ddUserId
            ? "点击关联"
            : `已关联钉钉【${
                dingName
                  ? dingName
                  : ruleFormDD.ddUserId
                  ? "1条数据"
                  : "未设置"
              }】`
        }}
      </el-button>
    </el-form-item>
       <el-form-item>
         <el-button type="primary" @click="submitFormDD('ruleFormRefDD')" style="margin:10px">提交</el-button>
         <el-button @click="handleClose" style="margin:10px">取消</el-button>
       </el-form-item>
     </el-form>
   </el-dialog>
    <!-- 钉钉用户列表弹窗 -->
    <el-dialog
      draggable
      v-if="dialogVisibleDingDing"
      title="钉钉用户列表"
      v-model="dialogVisibleDingDing"
      width="950px"
      class="abow_dialog publicDialogInline inlinePadding1 dialog-menu"
      :before-close="beforeClose"
      :close-on-click-modal="false"
      :params="GraderData"
      align-center="true"
    >
      <PermissionsTable
        rowKey="userId"
        :isAllSelect1="true"
        :params="{ keywords: '', userIds: [] }"
        :ids="ruleFormDD.ddUserId ? [ruleFormDD.ddUserId] : []"
        placeholder="姓名"
        :postText="'GetDepartmentListByKeywords'"
        @click-confirm="clickConfirm"
        :isPagination="false"
      >
      </PermissionsTable>
    </el-dialog>
  </div>
</template>

<script>
// 引入logout方法
import { logOut } from "network/login.js";
import { AdminLoginByRolesId } from "network/login.js";
import { isNull,nameBrowser } from "common/utils.js";
import { ElMessageBox } from "element-plus";
import RoleMenuItem from "./components/RoleMenuItem.vue";

export default {
  name: "Header",
  components: {
    RoleMenuItem,
  },
  props: {
    collapse: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    let verify = (rule, value, callback) => {
      const pswReg = /^(?=.*[0-9])(?=.*[a-zA-Z]).{8,20}$/;
      if (value === "" || value === undefined || value === null) {
        callback(new Error("请填写密码"));
      } else if (!pswReg.test(this.ruleForm.passWord)) {
        callback(new Error("密码必须数字与字母结合 长度必须大于8位且小于20位"));
      } else {
        callback();
      }
    };
    let isEqually = (rule, value, callback) => {
      if (value === "" || value === undefined || value === null) {
        callback(new Error("请填写确认密码"));
      } else if (this.ruleForm.passWordConfirm != this.ruleForm.passWord) {
        callback(new Error("两次密码不一致"));
      } else {
        callback();
      }
    };
    return {
      msg: "",
      maxRelationCount: "",
      userInfoData: {},
      addTypeList: [],
      roleName: "",
      dialogVisible: false,
      adminName: "",
      adminLogo: "",
      wxCodeImage: "",
      ruleForm: {
        passWord: "",
        passWordConfirm: "",
      },
      rules: {
        passWord: [
          {
            required: true,
            validator: verify,
          },
        ],
        passWordConfirm: [{ required: true, validator: isEqually }],
      },
      isTeacherImg: false,
      isStudentImg:false,
      loading:false,
      dialogVisibleDD:false,
      ruleFormDD:{
        ddUserId:''
      },
      rulesDD: {
        ddUserId: [
          {
            required: true,
            message: "选择钉钉账号",
            trigger: ["change", "blur"],
          },
        ],
      },
      dialogVisibleDingDing:false,
      dingName:'',
      departmentList:[],
      loadingPass:false,
      isChangePassword: false,
      isChangeDingUser: false,
    };
  },
  computed: {
    adminInfo() {
      const storeCache =
        this.$store &&
        this.$store.state &&
        this.$store.state.AdminCache;
      if (storeCache) {
        return storeCache;
      }
      const cacheStr = sessionStorage.getItem("AdminCache");
      if (cacheStr && cacheStr !== "undefined") {
        try {
          return JSON.parse(cacheStr);
        } catch (e) {
          return null;
        }
      }
      return null;
    },
    adminLogo() {
      if (this.adminInfo && this.adminInfo.adminLogo) {
        return this.adminInfo.adminLogo ? this.adminInfo.adminLogo : "";
      }
      return "";
    },
    name() {
      return this.adminInfo && this.adminInfo.adminName
        ? this.adminInfo.adminName
        : "静态数据";
    },
    logo() {
      const adminCache = this.adminInfo;
      const currentProject =
        adminCache && adminCache.roles
          ? adminCache.roles.find(role => role.isLoginIn === true)
          : null;
      return currentProject && currentProject.logoPath
        ? currentProject.logoPath
        : undefined;
    },
    headTextColor() {
      return (
        (this.$store.state.themeColor &&
          this.$store.state.themeColor.headTextColor) || "#fff"
      );
    },
    iconBGColor() {
      return (
        (this.$store.state.themeColor &&
          this.$store.state.themeColor.iconBGColor) || ""
      );
    },
    iconTextColor() {
      return (
        (this.$store.state.themeColor &&
          this.$store.state.themeColor.iconTextColor) || ""
      );
    },
    themeColorFromWebStyle() {
      const adminCache = this.adminInfo;
      if (adminCache && adminCache.webStyle) {
        try {
          const webStyle =
            typeof adminCache.webStyle === "string"
              ? JSON.parse(adminCache.webStyle)
              : adminCache.webStyle;
          return webStyle.ThemeColor || "#409EFF";
        } catch (e) {
          return "#409EFF";
        }
      }
      return "#409EFF";
    },
    roleName() {
      const adminCache = this.adminInfo;
      if (adminCache && adminCache.roles && Array.isArray(adminCache.roles)) {
        const currentRole = adminCache.roles.find(
          role => role.isLoginIn === true
        );
        return currentRole ? currentRole.roleName : "";
      }
      return "";
    },
    adminId() {
      return (this.adminInfo && this.adminInfo.adminId) || "";
    },
    currentRole() {
      const adminCache = this.adminInfo;
      if (adminCache && adminCache.roles && Array.isArray(adminCache.roles)) {
        return (
          adminCache.roles.find(role => role.isLoginIn === true) || null
        );
      }
      return null;
    },
    projectsList() {
      const adminCache = this.adminInfo;
      if (adminCache && adminCache.roles && Array.isArray(adminCache.roles)) {
        const projectsMap = {};
        adminCache.roles.forEach(role => {
          if (role.projectName) {
            if (!projectsMap[role.projectName]) {
              projectsMap[role.projectName] = {
                projectName: role.projectName,
                roles: [],
              };
            }
            projectsMap[role.projectName].roles.push(role);
          }
        });
        return Object.values(projectsMap);
      }
      return [];
    },
    otherProjectsList() {
      const adminCache = this.adminInfo;
      if (adminCache && adminCache.roles && Array.isArray(adminCache.roles)) {
        const projectsMap = {};
        adminCache.roles.forEach(role => {
          if (role.projectName) {
            if (!projectsMap[role.projectName]) {
              projectsMap[role.projectName] = {
                projectName: role.projectName,
                logoPath: role.logoPath,
                project: role.project,
                roles: [],
              };
            }
            projectsMap[role.projectName].roles.push(role);
          }
        });
        return Object.values(projectsMap);
      }
      return [];
    },
  },

  updated() {
    let adminInfoToken = sessionStorage.getItem("AdminToken")
      ? JSON.parse(sessionStorage.getItem("AdminToken"))
      : null;
    this.$nextTick(() => {
      if (adminInfoToken) {
        this.adminName =
          this.adminInfo && this.adminInfo.adminName
            ? this.adminInfo.adminName
            : this.name;
      } else {
        this.adminName = this.name;
      }
    });
  },
  created() {
    let adminInfoToken = sessionStorage.getItem("AdminToken")
      ? JSON.parse(sessionStorage.getItem("AdminToken"))
      : null;
    if (!adminInfoToken) {
      this.adminName = this.name;
    }
    this.setThemeFromWebStyle();
  },
  methods: {
    setThemeFromWebStyle() {
      const adminCache = this.adminInfo;
      if (adminCache && adminCache.webStyle) {
        try {
          const webStyle =
            typeof adminCache.webStyle === "string"
              ? JSON.parse(adminCache.webStyle)
              : adminCache.webStyle;
          if (webStyle.ThemeColor) {
            this.$store.dispatch("changeSetting", {
              key: "theme",
              value: webStyle.ThemeColor,
            });
          }
        } catch (e) {
          console.log("解析webStyle失败", e);
        }
      }
    },
    submitForm(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          this.loadingPass = true;
          const adminId =
            this.adminInfo && this.adminInfo.adminId
              ? this.adminInfo.adminId
              : "";
          let obj = {
            id: adminId,
            passWord: this.ruleForm.passWord,
            passWordConfirm: this.ruleForm.passWordConfirm,
          };
          const res = await SettingPassword(obj);
          if (res && res.code == 1) {
            this.loadingPass = false;
            ElMessageBox.alert("登陆密码修改成功,请重新登陆", "提示", {
              confirmButtonText: "确定",
              showClose: false,
              callback: () => {
                this.handleClose();
                this.logoutClick();
              },
            });
          } else {
            ElMessageBox.alert(res.message);
          }
        } else {
        }
      });
    },
    setPasswordClick() {
      this.dialogVisible = true;
    },
    handleClose() {
      this.ruleForm.passWord = "";
      this.ruleForm.passWordConfirm = "";
      this.dialogVisible = false;
      this.isTeacherImg = false;
      this.dialogVisibleDD = false;
      this.ruleFormDD.ddUserId = "";
      this.dingName = "";
      this.isStudentImg = false;
    },
    logoutClick() {
      const defaultUrl = 'https://sb.hbzsb.cn/';
      let sessionCache = null;
      sessionCache = JSON.parse(sessionStorage.getItem('AdminCache'));
      if(sessionCache.projectsId == 1){
        logOut();
        this.$router.go(0);
        return;
      }
      const rawUrl = sessionCache?.centerAdminUrl || defaultUrl;
      const centerAdminUrl = rawUrl?.trim() || defaultUrl;
      sessionStorage.clear();
      const logoutUrl = `${centerAdminUrl}?logOut=true`;
      window.location.replace(logoutUrl);
    },
    closeDialog(val) {
      if (!val) {
        this.dialogVisible = false;
        this.dialogVisibleAdmin = false;
        this.dialogVisibleStudent = false;
      }
      if (val == true) {
        this.dialogVisible = false;
        this.dialogVisibleAdmin = false;
        this.dialogVisibleStudent = false;
        var exit;
        clearTimeout(exit);
        exit = setTimeout(function () {
          logOut();
        }, 1000);
      }
      if (val == false) {
        this.dialogVisible = false;
        this.dialogVisibleAdmin = false;
        this.dialogVisibleStudent = false;
        this.getUserInfoData(this.adminId);
      }
    },
    enterBlock(event, classnName) {
      event.currentTarget.firstElementChild.classList.remove(classnName);
      event.currentTarget.firstElementChild.classList.add(classnName + "2");
    },
    leaveBlock(event, classnName) {
      event.currentTarget.firstElementChild.classList.remove(classnName + "2");
      event.currentTarget.firstElementChild.classList.add(classnName);
    },
    async setAdminDDUser() {
      this.dialogVisibleDD = true;
      const data = await requestPort["GetDepartmentListByKeywords"]({
        Ids: [],
      });
      this.departmentList = data.result;
      const adminId =
        this.adminInfo && this.adminInfo.adminId
          ? this.adminInfo.adminId
          : "";
      const res = await GetAdminInfo(adminId);
      if (res && res.code == 1) {
        this.departmentList.forEach(item => {
          if (item.userId == res.result.ddUserId) {
            this.dingName = item.name || "";
          }
        });
        this.ruleFormDD.ddUserId = res.result.ddUserId;
      } else {
        this.ruleFormDD.ddUserId = "";
        this.dingName = "";
      }
    },
    clickDingModule() {
      this.dialogVisibleDingDing = true;
    },
    clickConfirm(val) {
      this.dialogVisibleDingDing = false;
      this.$refs.ruleFormRefDD.clearValidate();
      if (val.Ids && val.Ids.length > 0) {
        if (isNull(val.moduleName)) {
          this.departmentList.forEach(item => {
            if (item.userId == val.Ids[0]) {
              this.dingName = item.name;
            }
          });
        } else {
          this.dingName = val.moduleName;
        }
        this.ruleFormDD.ddUserId = val.Ids[0] ? val.Ids[0] : "";
      } else {
        this.ruleFormDD.ddUserId = "";
        this.dingName = "";
      }
    },
    submitFormDD(formName) {
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const adminId =
            this.adminInfo && this.adminInfo.adminId
              ? this.adminInfo.adminId
              : "";
          let obj = {
            adminId,
            ddUserId: this.ruleFormDD.ddUserId,
          };
          const res = await SetAdminDDUser(obj);
          if (res && res.code == 1) {
            ElMessage({
              message: res.message,
              type: "success",
            });
            this.handleClose();
          } else {
            ElMessageBox.alert(res.message);
          }
        } else {
          return false;
        }
      });
    },
    async navigateToRole(pcSiteUrl, role) {
      if (!pcSiteUrl || pcSiteUrl.trim() === "") {
        this.$message.warning("该角色暂无PC端地址");
        return;
      }
      try {
        let userAgent = nameBrowser();
        if (!role.adminId) {
          this.$message.warning("管理员信息不存在");
          return;
        }
        ElMessageBox.confirm("请选择打开方式", "登录确认", {
          confirmButtonText: "新窗口打开",
          cancelButtonText: "当前窗口打开",
          type: "warning",
          distinguishCancelAndClose: true,
          closeOnClickModal: false,
          showClose: true,
        })
          .then(async () => {
            const res = await AdminLoginByRolesId({
              rolesId: role.roleId,
              loginType: 3,
              isLinkAdminId: role.isLinkAdminId,
              adminId: role.adminId,
            });
            if (res.code == 1) {
              const targetUrl = `${pcSiteUrl}?key=${res.result}`;
              window.open(targetUrl, "_blank");
            } else {
              ElMessageBox.alert(res.message);
            }
          })
          .catch(async action => {
            if (action === "cancel") {
              const res = await AdminLoginByRolesId({
                rolesId: role.roleId,
                loginType: 3,
                isLinkAdminId: role.isLinkAdminId,
                adminId: role.adminId,
              });
              if (res.code == 1) {
                const targetUrl = `${pcSiteUrl}?key=${res.result}`;
                window.location.replace(targetUrl);
              } else {
                ElMessageBox.alert(res.message);
              }
            }
          });
      } catch (error) {
        console.error("角色跳转失败:", error);
        this.$message.error("角色跳转失败，请重试");
      }
    },
  },
};
</script>

<style scoped>

/* 菜单 顶部 logo */
.header-left {
  font-size: 18px;
  font-weight: bold;
  height: 47px;
  line-height: 47px;
  overflow: hidden;
  width: 180px;
  float: left;
  background-color: var(--HeadBgColor, #344154);
  text-align: center;
  position: relative;
  z-index: 99;
  /* margin: 0 20px; */
}
.dropdown_title{
  height: 47px;
  line-height: 47px;
  font-size: 14px;
  color: var(--HeadTextColor, #fff);
}
.title-i{
  vertical-align: middle;
  margin-right: 5px;
}
.title-i-r{
  vertical-align: middle;
  margin-left: 5px;
}
.item-i{
  vertical-align: middle;
}
.header-left a {
  width: 70%;
  color: var(--HeadTextColor, #fff);
}

.logo {
  height: 22px;
  margin-top: -1px;
  margin-right: 4px;
}
.header-wrapper {
  height: 47px;
  color: #8291a9;
  overflow: hidden;
  background-color: var(--HeadBgColor, #344154);
}

.header-right {
  margin-right: 18px;
  font-size: 16px;
  color: #000000;
  background: #ffffff;
  box-shadow: 0px 2px 10px 1px rgba(0, 21, 41, 0.02);
  display: flex;
  align-items: center;
  justify-content: space-between;
  background: transparent;
  /* margin-left: 32px; */
}
.header-right .adminRole {
  height: 30px;
  color: var(--themeColor, "#333");
  border: 1px solid var(--themeColor, "#333");
  border-radius: 99px;
  padding: 0px 14px;
  background: #fff;
  box-sizing: border-box;
  line-height: 30px;
}

.btn-collect.btn-collect-left {
  margin-right: 12px;
  padding: 0 8px;
  border-radius: 4px;
  transition: all 0.3s ease;
}
.btn-collect.btn-collect-left:hover {
  background-color: rgba(255, 255, 255, 0.1);
}
.btn-collect {
  padding: 0 4px;
  cursor: pointer;
  font-size: 31px;
  color: var(--HeadTextColor, #fff);
  position: relative;  /* 添加相对定位 */
}

.btn-collect i {
  margin-right: 4px;
}
.line {
    display: inline-block;
    vertical-align: middle;
    width: 1px;
    height: 18px;
    margin: 0 15px;
    margin-top: 15px;
    background-color: hsla(0, 0%, 100%, .7);
   
}
.logo1{
  width: 170px;
  height: 29px;
  object-fit: contain;
}
.custom-dropdown {
  text-align: center;
  cursor: pointer;
  color: #8291a9;
  margin-right: 20px;
}

.custom-dropdown-list {
  min-width: 120px;
  text-align: center;
}
.el-dropdown-link {
  font-size: 18px;
  /* color: #fff; */
  margin-left: 10px;
}
.el-dropdown-link .icon_box {
  width: 24px;
  height: 24px;
  position: relative;
  border-radius: 50%;
  display: inline-block;
  /* top: 12px; */
  background: #334154;
}
.icon_box.top {
  top: 12px;
}
.el-dropdown-link .icon_box i {
  vertical-align: super;
}
.item-btn {
  display: block;
}
.img {
  text-align: center;
}
.img img {
  width: 250px;
  height: 250px;
  margin: 10px 0;
}
.img-tips{
  height: 45px;
  line-height: 45px;
  color: red;
}
.dialogprop >>> .el-dialog__body {
  margin-top: -15px;
}
.admin_name {
  height: 14px;
  font-size: 14px;
  margin-left: 10px;
  color: var(--HeadTextColor, #fff);
  line-height: 24px;
}
.el-icon-user {
  vertical-align: super;
}
.el-icon-user:before {
  font-size: 14px;
  margin-top: 5px;
  display: inline-block;
}
.fl {
  float: left;
  height: 47px;
}
::v-deep .el-form-item__content {
  margin-left: 0 !important;
  justify-content: center !important;
}
::v-deep .el-input--default {
  height: 40px !important;
}
::v-deep .el-button--default {
  width: 70px;
  height: 40px;
}
/* 项目选项卡容器样式 */
.project-tabs-container {
  display: flex;
  align-items: center;
  gap: 10px;
  margin-right: auto;
  margin-left: 50px;
}
/* 项目选项卡样式 */
.project-tab {
  margin-right: 30px;
}
.project-tab-title {
  height: 47px;
  line-height: 47px;
  font-size: 15px;
  color: var(--HeadTextColor, #fff);
  cursor: pointer;
}

/* 项目图标样式 */
.project-icon {
  vertical-align: middle;
    margin-right: 5px;
}
.project-logo {
  width: 32px;
  height: 32px;
  margin-right: 6px;
  object-fit: contain;
}
.project-name {
  margin: 0 2px;
  font-weight: 600;
  color: #ffffff;
}
.project-arrow {
  vertical-align: middle;
  margin-right: 5px;
}
/* 角色下拉菜单样式 */
.project-dropdown-menu {
  min-width: 120px;
}
.role-item {
  width: 100%;
  display: flex;
  align-items: center;
  padding: 8px 12px;
  box-sizing: border-box;
  color: #333;
  cursor: pointer;
  transition: background-color 0.2s;
}
.disabled-role {
  cursor: not-allowed;
  color: #999;
}
.disabled-role:hover {
  background-color: transparent;
}
.current-role-tag {
  margin-left: auto;
  font-size: 12px;
  color: #67c23a;
  background-color: #f0f9ff;
  padding: 2px 6px;
  border-radius: 3px;
  margin-left: 8px;
}
.role-icon {
  margin-right: 6px;
}
 .message-count {
   position: absolute;
   top: 8px;
   right: -6px;
   min-width: 16px;
   height: 16px;
   line-height: 16px;
   padding: 0 4px;
   font-size: 12px;
   text-align: center;
   background: #f56c6c;
   border-radius: 16px;
   color: #fff;
   border: 1px solid #fff;
   z-index: 2;  /* 添加z-index确保显示在上层 */
 }

 /* 学员步骤样式 */
 .student-steps {
   margin-top: 15px;
   padding: 20px;
   background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
   border-radius: 12px;
   border: 1px solid #dee2e6;
   box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
 }

 .steps-header {
   display: flex;
   align-items: center;
   margin-bottom: 20px;
   padding-bottom: 12px;
   border-bottom: 2px solid #007bff;
   color: #007bff;
   font-size: 18px;
   font-weight: bold;
 }

 .steps-header i {
   margin-right: 8px;
   font-size: 20px;
 }

 .steps-content {
   display: flex;
   flex-direction: column;
   gap: 15px;
 }

 .step-item {
   display: flex;
   align-items: flex-start;
   padding: 12px 16px;
   background: #fff;
   border-radius: 8px;
   border-left: 4px solid #28a745;
   box-shadow: 0 2px 8px rgba(0, 0, 0, 0.08);
   transition: all 0.3s ease;
     
 }
.el-dropdown-item-l{
border-bottom: 1px solid #ebeef5;
}
 .step-item:hover {
   transform: translateX(5px);
   box-shadow: 0 4px 16px rgba(0, 0, 0, 0.15);
   border-left-color: #007bff;
 }

 .step-number {
   display: flex;
   align-items: center;
   justify-content: center;
   min-width: 28px;
   height: 28px;
   margin-right: 15px;
   background: linear-gradient(135deg, #007bff, #0056b3);
   color: #fff;
   border-radius: 50%;
   font-weight: bold;
   font-size: 14px;
   box-shadow: 0 2px 6px rgba(0, 123, 255, 0.3);
 }

 .step-text {
   flex: 1;
   line-height: 1.6;
   color: #495057;
   font-size: 14px;
   padding-top: 2px;
   text-align: left;
 }
 .el-dropdown, .el-dropdown * {
  outline: none !important;
 }
  .project-role-menu{
    max-height: 500px;
    overflow-y: scroll;
  }
  .role-logo{
  width: 24px;
  height: 24px;
  border-radius: 50%;
  object-fit: cover;
  margin-right: 5px;
}
</style>
